export default __webpack_public_path__ + "static/affiliate1VpImg-0529ee78d6cfaffa4692cfe0d2fc632b.png";